import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import config from '../../../../helpers/config';
import UnavailabilityModal from './UnavailabilityModal';
import CoveredByNobody from './CoveredByNobody';
import loading from '../../../../actions/loading';
import { sites } from '../../../../helpers/globalVariables';

const component = config.siteId !== sites.theHomeDepot ? UnavailabilityModal : CoveredByNobody;

const mapStateToProps = ({ estimateBuilder }) => {
  const { validationResult } = estimateBuilder.mandiAvailability;
  return { address: validationResult.address };
};

const mapDispatchToProps = dispatch => bindActionCreators({ loading }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(component);
